/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import axiosRetry from 'axios-retry';
import { integrationAdaptersApiPath } from '../settings';
import { getAccessToken } from '../redux/features/auth/auth.service';

const axios = require('axios').default;

// Configure axios-retry for the default axios instance
axiosRetry(axios, {
  retries: 3, // Number of retry attempts
  retryDelay: retryCount => retryCount * 1000, // Time between retries
});

const getHeaders = () => {
  const token = getAccessToken();
  return {
    'Cache-Control': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export default {
  fill: async (endpoint, value, params) => {
    return axios
      .get(`${integrationAdaptersApiPath}/${endpoint}/${value}`, {
        headers: getHeaders(),
        params,
      })
      .then(response => response?.data || null)
      .catch(() => Promise.resolve(null));
  },
};
